<p align="center">Veja abaixo os seus atendimentos semanais:</p>
<page-bar-chart [itens]="chartItens"></page-bar-chart>
